import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Navbar, Footer } from "../components/Layout";
import { PropertyCard, availabilityLabel } from "../components/PropertyCard";
import { useText } from "../contexts/TextsContext";

export default function Listings() {
  const [properties, setProperties] = useState([]);
  const [minSurface, setMinSurface] = useState("");
  const [availableBy, setAvailableBy] = useState("");
  const [loading, setLoading] = useState(true);
  const t = useText();

  useEffect(() => {
    api.get("/properties").then(r => setProperties(r.data)).finally(() => setLoading(false));
  }, []);

  const filtered = properties.filter(p => {
    if (minSurface && p.surface_max < parseInt(minSurface)) return false;
    if (availableBy) {
      // Show only properties whose available_from <= availableBy date
      const target = new Date(availableBy);
      const from = p.available_from ? new Date(p.available_from) : null;
      if (from && from > target) return false;
    }
    return true;
  });

  return (
    <div className="min-h-screen bg-[#F9F9F7]">
      <Navbar />
      <section className="border-b border-slate-900/10 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-8 py-16">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#FFC107] mb-4">{t("listings.kicker")}</div>
          <h1 className="font-display font-black text-4xl md:text-6xl tracking-tight mb-4">{t("listings.title")}</h1>
          <p className="text-slate-600 max-w-2xl">{t("listings.subtitle")}</p>

          <div className="flex flex-wrap gap-4 mt-10 items-end">
            <div>
              <label className="text-xs font-bold uppercase tracking-widest text-slate-500 mb-2 block">{t("listings.filter_label")}</label>
              <select data-testid="filter-surface" value={minSurface} onChange={e => setMinSurface(e.target.value)}
                className="border border-slate-900 bg-white px-4 py-3 font-mono text-sm focus:outline-none">
                <option value="">{t("listings.filter_all")}</option>
                <option value="270">≥ 270 m²</option>
                <option value="350">≥ 350 m²</option>
                <option value="420">≥ 420 m²</option>
              </select>
            </div>
            <div>
              <label className="text-xs font-bold uppercase tracking-widest text-slate-500 mb-2 block">{t("listings.filter_date_label")}</label>
              <input type="date" data-testid="filter-available-from" value={availableBy} onChange={e => setAvailableBy(e.target.value)}
                className="border border-slate-900 bg-white px-4 py-3 font-mono text-sm focus:outline-none" />
            </div>
            {(minSurface || availableBy) && (
              <button onClick={() => { setMinSurface(""); setAvailableBy(""); }} data-testid="filter-reset"
                className="text-xs font-bold uppercase tracking-wider border border-slate-900 px-4 py-3 bg-white">
                {t("listings.filter_reset")}
              </button>
            )}
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-8 py-16">
        {loading ? (
          <div className="text-center py-24 font-mono text-sm text-slate-500">{t("global.loading")}</div>
        ) : filtered.length === 0 ? (
          <div className="text-center py-24 font-mono text-sm text-slate-500">{t("listings.empty")}</div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="properties-grid">
            {filtered.map(p => <PropertyCard key={p.id} property={p} />)}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
